import React from "react";
import { styled } from "@mui/system";
import Prtfolio1 from "../assets/Deep Brain (1).png";
import Prtfolio2 from "../assets/shona shop 2.png";
import Prtfolio3 from "../assets/Chatbot ats.png";
import Prtfolio4 from "../assets/book recommender sys.png";
import Prtfolio5 from "../assets/portfolio site.png";

const Container = styled("section")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const InfoContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  margin: "30px",
});

const Subtitle5 = styled("h5")({
  fontSize: "12px",
  fontWeight: "500",
  color: "var(--color-light)",
});

const Title = styled("h1")({
  fontSize: "30px",
  color: "var(--color-primary)",
});

const Cards = styled("div")({
  display: "flex",
  padding: "20px",
  flexWrap: "wrap",
  width: "90vw",
  justifyContent: "space-between",
  "@media (max-width: 1020px)": {
    flexDirection: "column",
    alignItems: "center",
  },
});

const Card = styled("span")({
  display: "flex",
  flexDirection: "column",
  padding: "20px",
  margin: "20px",
  borderRadius: "20px",
  width: "500px",
  backgroundColor: "var(--color-bg-variant)",
  gap: "8px",
  transition: "all 1s ease",
  "&:hover": {
    // backgroundColor: '#1f1f38',
    border: "1px solid var(--color-primary)",
    transform: "scale(1.01)",
  },
  "@media (max-width: 480px)": {
    // flexDirection: 'column',
    width: "80%",
  },
});

const Image = styled("img")({
  borderRadius: "20px",
  overflow: "hidden",
  boxShadow: "1px 1px 4px 4px #1f1f3830",
});

const Content = styled("p")({
  fontSize: "16px",
  fontWeight: "500",
  margin: "10px",
  textAlign: "justify",
});

const Code = styled("div")({
  display: "flex",
});

const Button = styled("button")((props) => ({
  backgroundColor:
    props.type === "demo" ? "transparent" : "var(--color-primary)",
  color: props.type === "demo" ? "var(--color-primary)" : "var(--color-bg)",
  fontWeight: "600",
  cursor: "pointer",
  borderRadius: "5%",
  border: "1px solid var(--color-primary)",
  padding: "10px",
  margin: "10px",
  transition: "all 0.5s ease",
  "&:hover": {
    color: "var(--color-bg)",
    backgroundColor: "var(--color-white)",
    borderColor: "transparent",
    transform: "scale(1.05)",
  },
}));

function Portfolio() {
  return (
    <Container id="portfolio">
      <InfoContainer>
        <Subtitle5>My recent work</Subtitle5>
        <Title>Portfolio</Title>
      </InfoContainer>
      <Cards>
        <Card>
          <Image src={Prtfolio1} alt="App"></Image>
          <Content>
            This project develops a deep learning model for automatic brain
            tumor and intra-tumoral component segmentation (enhancing tumor,
            edema, necrosis) from 3D multimodal MRI scans (Flair, T1, T1C, T2).
            Built on a 3D U-Net architecture with CNN blocks, it was trained and
            evaluated on the BraTS 2021 benchmark dataset for medical image
            segmentation.
            <br />
            <br />
            Tools : Python, PyTorch, TensorFlow, Scikit-learn, Pandas,
            Matplotlib, Mango for 3D visualization, Google Drive for data
            storage, and Docker.
          </Content>

          <Code>
            <Button
              type="code"
              as="a"
              href="https://github.com/soniareffadpro/Brain-Tumor-Segmentation-DeepBrain-"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </Button>
            {/*<Button type='demo'>Live Demo</Button>*/}
          </Code>
        </Card>
        <Card>
          <Image src={Prtfolio2} alt="App"></Image>
          <Content>
            SHONA SHOP is a responsive ReactJS e-commerce app for online
            clothing sales, featuring product listings, detail pages with
            size/color selection, a shopping cart, and category filters. The
            interface adapts seamlessly to all screen sizes for a smooth
            shopping experience.
            <br />
            <br />
            Tools : ReactJs, Styled Components, React Router, Context API,
            responsive design techniques.
            <br />
            <br />
            <br />
          </Content>
          <Code>
            <Button
              type="code"
              as="a"
              href="https://github.com/soniareffadpro/Shona-Shop"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </Button>

            {/*<Button type='demo'>Live Demo</Button>*/}
          </Code>
        </Card>
        <Card>
          <Image src={Prtfolio3} alt="App"></Image>
          <Content>
            ATS-Chatbot is an AI-powered Applicant Tracking System that analyzes
            resumes and job descriptions to evaluate candidate-job fit,
            highlight missing skills, provide improvement feedback, and rank
            multiple resumes using semantic and skill-based similarity.
            <br />
            <br />
            Tools : LangChain, Groq Llama-3.1, Python, Streamlit, NLP
            techniques, semantic similarity metrics
          </Content>
          <Code>
            <Button
              type="code"
              as="a"
              href="https://github.com/soniareffadpro/ATS-Chatbot"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </Button>
            {/*<Button type='demo'>Live Demo</Button>*/}
          </Code>
        </Card>
        <Card>
          <Image src={Prtfolio4} alt="App"></Image>
          <Content>
            This Book Recommender System uses a{" "}
            <a
              href="https://www.kaggle.com/datasets/ra4u12/bookrecommendation"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "var(--color-white)",
                textDecoration: "underline",
              }}
            >
              Kaggle dataset
            </a>{" "}
            of books, users, and ratings. It builds a sparse user-item matrix
            and applies the Nearest Neighbors algorithm to recommend the top 5
            similar books with cover images.
            <br />
            <br />
            Tools: Python, Pandas, NumPy, Scikit-learn, SciPy, Streamlit
          </Content>

          <Code>
            <Button
              type="code"
              as="a"
              href="https://github.com/soniareffadpro/books_recommender_system"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </Button>
            {/*<Button type='demo'>Live Demo</Button>*/}
          </Code>
        </Card>
        <Card>
          <Image src={Prtfolio5} alt="App"></Image>
          <Content>
            This portfolio website showcases a professional journey through a
            clean and modern interface. It presents background, skills,
            education, services, and selected projects in a visually structured
            way. Built with ReactJS and Material UI, the website emphasizes
            simplicity, responsiveness, and smooth navigation to deliver an
            engaging experience for visitors.
            <br />
            <br />
            Tools : ReactJS, HTML, CSS, JavaScript, Material UI, Responsive
            Design.
          </Content>
          <Code>
            <Button
              type="code"
              as="a"
              href="https://github.com/soniareffadpro/Portfolio-Site"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </Button>

            {/*<Button type='demo'>Live Demo</Button>*/}
          </Code>
        </Card>
        {/* <Card>
          <Image src={Prtfolio6} alt="App"></Image>
          <Content>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit
          </Content>
          <Code>
            <Button type="code">GitHub</Button>
            
          </Code>
        </Card> */}
      </Cards>
    </Container>
  );
}

export default Portfolio;
